import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const StyledEditButton = styled(IconButton)`
    display: none;

    & ${SWReactIcons} {
        height: 20px;
        width: 20px;

        & svg path {
            fill: ${colorsPalettes.carbon["200"]};
            fill-opacity: 1;
        }
    }
`;

export const StyledSimilarwebIconWrap = styled.div`
    margin-left: 10px;

    & ${SWReactIcons} {
        height: 13px;
        width: 13px;
    }
`;

export const StyledItemText = styled.span`
    ${mixins.setFontVariant("input2", colorsPalettes.carbon["500"])};
    line-height: 16px;
`;

export const StyledItemTextWrapper = styled.div`
    align-items: center;
    display: flex;
    max-width: calc(100% - 40px);
    overflow-wrap: anywhere;
    padding: 14px 0;
`;

export const StyledDropdownItem = styled.div`
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    min-height: 44px;
    justify-content: space-between;
    padding: 0 16px;

    &:hover {
        background-color: ${colorsPalettes.bluegrey["100"]};

        & ${StyledEditButton} {
            display: flex;
        }
    }

    &.--selected {
        background-color: ${colorsPalettes.bluegrey["100"]};
    }
`;
